<div class="container-fluid">
  <div class="container-head mt-2">

    <div class="row">
      <div class="col">
        Welcome
      </div>
    </div>
  </div>
</div>